import React from "react";
import "./Header.css";
import { slide as Menu } from 'react-burger-menu'
import * as Scroll from 'react-scroll';
import { Link, Button, Element, Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'


class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }
  render() {
    return (
      <header >
        <div className="container" style={{ position: 'relative', display: 'flex', justifyContent: 'flex-end' }}>
          <Menu width={'100%'} right >
            <img src="img/logo.png" />
            <a className="menu-item" href="/">Home</a>
            <Link to="About" spy={true} smooth={true} offset={50} duration={500} >About Us</Link>
            <Link to="Why" spy={true} smooth={true} offset={0} duration={500} >Why Squirrel</Link>
            <Link to="Partners" spy={true} smooth={true} offset={50} duration={500} >Partners</Link>
            <Link to="How" spy={true} smooth={true} offset={50} duration={500} >How It Works </Link>
            <Link to="Nuts" spy={true} smooth={true} offset={50} duration={500} >NUTS Token</Link>
            <Link to="Contact" spy={true} smooth={true} offset={50} duration={500} >Contact</Link>
          </Menu>
        </div>

        <div className="container">
          <div className="header_main">
            <a href="/">
              <img src="img/logo.png" />
            </a>
            <ul className="header_menu">
              <li>
                <a href='/'>Home</a>
              </li>
              <li>
                <Link to="About" spy={true} smooth={true} offset={50} duration={500} >About Us</Link>
              </li>
              <li>
                <Link to="Why" spy={true} smooth={true} offset={0} duration={500} >Why Squirrel</Link>
              </li>
              <li>
                <Link to="Partners" spy={true} smooth={true} offset={50} duration={500} >Partners</Link>
              </li>
              <li>
                <Link to="How" spy={true} smooth={true} offset={50} duration={500} >How It Works </Link>
              </li>
              <li>
                <Link to="Nuts" spy={true} smooth={true} offset={50} duration={500} >NUTS Token</Link>
              </li>
              <li>
                <Link to="Contact" spy={true} smooth={true} offset={50} duration={500} >Contact</Link>
              </li>
            </ul>
          </div>
        </div>

      </header>
    );
  }
}

export default Header;
